@if (loadingService.isLoading()) {
  <div class="loading-container">
    <div class="loading-bar"></div>
  </div>
}

<router-outlet></router-outlet>
